import { render, staticRenderFns } from "./VerProveedorModal.vue?vue&type=template&id=061e4af6&"
import script from "./VerProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./VerProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports